import * as React from "react";

export default function CircularUnderLoad(props) {
  return <div className="cover-spin"></div>;
}
